// extracted by mini-css-extract-plugin
export default {"User":"User_User__qq1Qd"};